import { ApiClientInstance } from '@shared/api';
import { TProfileSecurityResponse } from './types';

export const profileSecurity = (): Promise<TProfileSecurityResponse> => {
  return ApiClientInstance.get<TProfileSecurityResponse>('v2/profile/security');
};
